var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.45328 5.99991C8.82147 5.99991 9.11994 6.29838 9.11994 6.66657V9.33323C9.11994 9.70142 8.82147 9.9999 8.45328 9.9999C8.08509 9.9999 7.78661 9.70142 7.78661 9.33323V6.66657C7.78661 6.29838 8.08509 5.99991 8.45328 5.99991Z",
    fill: "#F86069"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.45328 12.6666C8.82147 12.6666 9.11994 12.3681 9.11994 11.9999C9.11994 11.6317 8.82147 11.3332 8.45328 11.3332C8.08509 11.3332 7.78661 11.6317 7.78661 11.9999C7.78661 12.3681 8.08509 12.6666 8.45328 12.6666Z",
    fill: "#F86069"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.74329 2.89414C7.10585 2.29642 7.7542 1.9314 8.45328 1.9314C9.15237 1.9314 9.80071 2.29642 10.1633 2.89414L10.1652 2.8973L15.8118 12.324L15.8173 12.3332C16.1726 12.9486 16.1747 13.7063 15.8228 14.3237C15.4709 14.9411 14.8178 15.3253 14.1073 15.3331L14.0999 15.3332L2.7993 15.3332C2.08872 15.3254 1.43564 14.9411 1.08373 14.3237C0.731828 13.7063 0.73395 12.9486 1.08931 12.3332L1.09472 12.324L6.74137 2.89731L6.74329 2.89414ZM7.88409 3.58431L2.24175 13.0038C2.1255 13.2082 2.12553 13.4589 2.2421 13.6634C2.3589 13.8683 2.57522 13.9962 2.81089 13.9999H14.0957C14.3313 13.9962 14.5477 13.8683 14.6645 13.6634C14.781 13.4589 14.7811 13.2082 14.6648 13.0038L9.02328 3.58564L9.02247 3.58431C8.90146 3.38586 8.68579 3.26473 8.45328 3.26473C8.22077 3.26473 8.0051 3.38586 7.88409 3.58431Z",
    fill: "#F86069"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.80999d66.svg";
export { ForwardRef as ReactComponent };